import React from 'react'
import { useHistory } from 'react-router-dom';
import MenuCard from '../../../../utils/components/MenuCard/MenuCard'
import { AddList,  TransferIcon, ReturnIcon } from '../../../../assets/icons';
import TitleSVG from '../../../../utils/components/TitleSVG/TitleSVG';
import style from './Transfer.module.css'

const Transfers = () => {
    const history = useHistory()
    return (
        <div className={`${style.container}`}>

            <TitleSVG Icon={TransferIcon} titleHighlight={'T'} title={'ransferencias'} />

            <div className={`${style.container_options}`}>
                <MenuCard
                    text={'Crear'}
                    onClick={() => {
                        history.push('/Admin/Inventory/CreateTranferWithoutOrder')
                    }}
                    Icon={AddList}
                    hasOnClick={true}
                />

                <MenuCard
                    text={'Órdenes'}
                    onClick={() => {
                        history.push('/Admin/Inventory/PendingOrders')
                    }}
                    Icon={TransferIcon}
                    hasOnClick={true}
                />

                <MenuCard
                    text={'Histórico'}
                    onClick={() => {
                        history.push('/Admin/Inventory/TransferHistory')
                    }}
                    Icon={ReturnIcon}
                    hasOnClick={true}
                />
            </div>
        </div>
    )
}

export default Transfers
